import { Button } from '@cian/ui-kit';
import { IconActionMore16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './AddedFavoriteEntityMenu.css';
import { trackMoreMenuItemClick, EMoreMenuItems } from './trackings';
import { EDealType } from '../../repositories/favorites/entities/favorite_entity_for_desktop/FavoriteEntityForDesktopSchema';
import { EEntityType } from '../../types/filters';
import { getDocxUrl, getPdfUrl } from '../../utils/downloads';
import { ClickOutside } from '../ClickOutside';

export interface IAddedFavoriteEntityMenuProps {
  entityId: number;
  dealType: EDealType | null;
  favoriteEntityType: EEntityType | null;
}

export interface IAddedFavoriteEntityMenuState {
  isDropdownVisible: boolean;
}

export class AddedFavoriteEntityMenu extends React.Component<
  IAddedFavoriteEntityMenuProps,
  IAddedFavoriteEntityMenuState
> {
  public state = {
    isDropdownVisible: false,
  };

  public render() {
    const { isDropdownVisible } = this.state;
    const { dealType, favoriteEntityType, entityId } = this.props;

    const docxUrl = getDocxUrl(dealType, favoriteEntityType, entityId);
    const pdfUrl = getPdfUrl(dealType, favoriteEntityType, entityId);

    return (
      <ClickOutside onOutside={() => this.setDropdownVisible(false)}>
        <div className={styles['container']}>
          <Button
            size="XS"
            theme="fill_secondary"
            beforeIcon={<IconActionMore16 color="icon-main-default" />}
            onClick={() => this.setDropdownVisible(!this.state.isDropdownVisible)}
          />
          {isDropdownVisible && (
            <div className={styles['added_info']}>
              {pdfUrl && (
                <a href={pdfUrl} target="_self" download onClick={() => trackMoreMenuItemClick(EMoreMenuItems.Pdf)}>
                  Скачать в PDF
                </a>
              )}
              {docxUrl && (
                <a href={docxUrl} target="_self" download onClick={() => trackMoreMenuItemClick(EMoreMenuItems.Doc)}>
                  Скачать в DOC
                </a>
              )}
            </div>
          )}
        </div>
      </ClickOutside>
    );
  }

  private setDropdownVisible = (visible: boolean) => this.setState({ isDropdownVisible: visible });
}
